var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.validate
    ? _c("ValidationProvider", {
        ref: "provider",
        attrs: { rules: _vm.rules, slim: "" },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("div", { staticClass: "row form-group text-area-row" }, [
                    _c(
                      "span",
                      {
                        class: [
                          _vm.labelClass
                            ? _vm.labelClass
                            : "col-xs-12 col-sm-5",
                          "col-form-label calculated-row",
                          _vm.bold ? "bold" : ""
                        ]
                      },
                      [
                        _vm.doNotUseResources
                          ? _c("span", [_vm._v(_vm._s(_vm.title))])
                          : _c("span", [_vm._v(_vm._s(_vm.$t(_vm.title)))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          _vm.valueClass
                            ? _vm.valueClass
                            : "col-xs-12 col-sm-7",
                          "col-form-label calculated-row"
                        ]
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value,
                              expression: "value"
                            }
                          ],
                          staticClass: "d-none",
                          attrs: {
                            "aria-hidden": "true",
                            "aria-label": "hidden field for validation"
                          },
                          domProps: { value: _vm.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.value = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { class: { "float-right": _vm.alignRight } },
                          [
                            _vm.formatNumber
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { "white-space": "pre-wrap" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm._f("formatNumber")(_vm.value))
                                    )
                                  ]
                                )
                              : _c("span", {
                                  staticStyle: { "white-space": "pre-wrap" },
                                  domProps: { innerHTML: _vm._s(_vm.value) }
                                }),
                            _vm._v(" "),
                            _vm.sign
                              ? _c("span", [_vm._v(_vm._s(_vm.sign))])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-1 col-sm-1 col-1" }, [
                      _vm.hasErrors(failedRules) && !_vm.isReadOnly
                        ? _c(
                            "span",
                            { staticClass: "float-left warning-text" },
                            [
                              _c("i", {
                                staticClass:
                                  "fas fa-exclamation-triangle fa-lg icon textrow-icon"
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ]
              }
            }
          ],
          null,
          false,
          953806750
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }